jQuery.noConflict();

var povprasevanje;

(function($) {

    $(document).ready(function(){

        var isMobile = false; //initiate as false
        // device detection
        if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) isMobile = true;

        $(".gallery-icon a:not(.link)").fancybox();

        (function () {
            $('.filter-control').on('change', function () {
                $(this).closest('form').submit();
            });
        })();




        //Menu fixer
        // $(window).scroll(menuFixer);
        //
        // function menuFixer() {
        //     let scroll = $(window).scrollTop(),
        //         $body = $('body');
        //
        //     if (scroll >= 50) {
        //         $body.addClass('nav-fixed');
        //     } else {
        //         $body.removeClass('nav-fixed');
        //     }
        // }
        // menuFixer();



        (function () {
            // When the user scrolls the page, execute myFunction
            window.onscroll = function() { StickyHeader() };
            // Get the navbar
            var navbar = document.getElementById("wrapper-navbar");
            var htmlbody = document.body;
            // Get the offset position of the navbar
            var sticky = navbar.offsetTop;
            // Add the sticky class to the navbar when you reach its scroll position. Remove "sticky" when you leave the scroll position
            function StickyHeader() {
                if (window.pageYOffset >= 150) {
                    navbar.classList.add("sticky");
                    htmlbody.classList.add('sticky-on');
                } else {
                    navbar.classList.remove("sticky");
                    htmlbody.classList.remove('sticky-on');
                }
  
            }
        })();



        (function () {
            $('.masonry').masonry({
                columnWidth: '.grid-sizer',
                itemSelector: '.type-poslovalnica',
                gutter: 30
            });
        })();


        function ajaxHelper(data, action) {
            return new Promise(function (resolve, reject) {
                if ( ! data ) {
                    reject('didnt get data object');
                }
                $.ajax({
                    url: localize.ajaxurl,
                    data: {
                        'action' : action,
                        'data' : data
                    },
                    type: 'POST',
                    success: function( response ) {
                        if ( response ) {
                            resolve(response);
                        } else {
                            reject('Something Went Wrong');
                        }
                    }
                });
            });
        }





        (function () {
            let padding = ($( document ).width() - 760)/2;

            $(".owl-carousel").owlCarousel(
                {
                    loop:true,
                    nav:true,
                    center:true,
                    items: 1,
                    dots: false,
                    mouseDrag: false,
                    autoplay: true,
                    margin: 16,
                    dotsContainer: $('.custom-dots'),
                    navContainer: $('.custom-nav'),
                    navText: ['<i class="fas fa-arrow-left"></i>', '<i class="fas fa-arrow-right"></i>'],
                    responsive:{
                        // 0:{
                        //     items:1,
                        //     nav:true
                        // },
                        760:{
                            stagePadding: padding,

                        },
                    }
                }
            );
        })();


        $(".mm").owlCarousel(
            {
                loop:true,
                animateOut: 'fadeOut',
                animateIn: 'fadeIn',
                // center:true,
                items: 1,
                dots: true,
                nav:false,
                mouseDrag: false,
                autoplay: false,
                margin: 16,
                dotsContainer: $('.custom-nav'),
                // navText: ['<i class="fas fa-chevron-left"></i>', '<i class="fas fa-chevron-right"></i>'],
                // responsive:{
                //     0:{
                //         items:1,
                //         nav:true
                //     },
                //     760:{
                //         items:3,
                //         nav:false
                //     },
                // }
            }
        );
        
        $('#emi-notice').on('closed.bs.alert', function () {
            setCookie('hideNotice', true, 1);
        });

        (function () {
            let sTrigger = $('#search-trigger'),
                sWrapper = $('#search-wrapper'),
                $body = $('body'),
                $overlay = $('.overlay'),
                $close = sWrapper.find('.close');

            sWrapper.open = false;
            sWrapper.toggler = function(){
                this.toggleClass('active');
                $body.toggleClass('overlay-active').toggleClass('prevent-scroll');
                sWrapper.open = !sWrapper.open;
            };
            sWrapper.closer = function() {
                this.removeClass('active');
                $body.removeClass('overlay-active').removeClass('prevent-scroll');
                sWrapper.open = false;
            };

            sTrigger.on('click', function (e) {
               e.preventDefault();
               sWrapper.toggler();
            });

            $close.add($overlay).on('click', function (e) {
                e.preventDefault();
               sWrapper.closer();
            });
        })();




        function setCookie(cname, cvalue, exdays) {
            let d = new Date();
            d.setTime(d.getTime() + (exdays*24*60*60*1000));
            let expires = "expires="+ d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }



        //These will be updated on window.resize
        //If you want an element to have any of its properties
        //calculated dynamically, please push it to this array in object format
        //Structure of object should be:
        /*
        {
            'element': $('#element'),
            'property': 'padding-left',
            'callback': calcFluidPadding
        }
        */
        let dynamicElements = [];

        function updateDynamicElements() {
            for (const element of dynamicElements) {
                element.element.css(element.property, element.callback)
            }
        }


        //Gforms
        (function () {
            $('ul.gfield_radio input').on('click', function() {
                let that = $(this);
                that.closest('.gfield_radio').find('li').removeClass('checked');
                that.closest('li').addClass('checked');
            });

            if( window.gform ) {


                gform.addFilter( 'gform_datepicker_options_pre_init', function( options, formId, fieldId ) {

                    var className = 'datepicker-clean';

                    if( ! $( '#input_' + formId + '_' + fieldId ).parents( 'li.gfield' ).hasClass( className ) ) {
                        return options;
                    }


                    var beforeShow = options.beforeShow,
                        onClose    = options.onClose;

                    options.numberOfMonths = 2;
                    options.changeMonth = false;
                    options.changeYear = false;
                    options.showOtherMonths = true;
                    options.dayNamesMin = [ 'S', 'M', 'T', 'W', 'T', 'F', 'S' ];
                    options.beforeShow = function(textbox, instance) {
                        beforeShow();
                        $( '#ui-datepicker-div' ).addClass( className );

                    };
                    options.onClose = function() {
                        onClose();
                        var closeInterval = setInterval( function() {
                            var $dp = $( '#ui-datepicker-div' );
                            if( ! $dp.is( ':visible' ) ) {
                                $dp.removeClass( className );
                                clearInterval( closeInterval );
                            }
                        }, 100 );
                    };

                    return options;
                } );

            }
        })();


        (function () {

            // if (!isMobile){
                let $frame = $('.frame'),
                    $scrollbar = $('.o-scrollbar');

                if ($frame.length > 0) {
                    dynamicElements.push({
                            'element': $frame,
                            'property': 'padding-left',
                            'callback': calcFluidPadding
                        }
                    );

                    $frame.css('padding-left', calcFluidPadding());

                    new Sly($frame, {
                        horizontal: 1,
                        itemNav: 'basic',
                        smart: 0,
                        mouseDragging: 1,
                        touchDragging: 1,
                        releaseSwing: 0,
                        speed: 300,
                        dragHandle: 1,
                        dynamicHandle: 1,
                        scrollBar: $scrollbar,
                        cycleBy: 'items',
                        clickBar: true,
                    }).init();
                }
            // }

        })();

        $(window).on('resize', function () {
            updateDynamicElements();
        });


        function calcFluidPadding() {
            let $container = $('.container');

             return ($( 'body' ).width() - $container.width()) / 2;
        }


        let mobileMenu = {
            open: false,
            items: {
                hamburger: $('#burger'),
                burgerWrapper: $('#burger-wrapper'),
                navbar: $('.header-container'),
                body: $('body')
            },
            functions: {
                toggle: function () {
                    this.items.hamburger.toggleClass('animate');
                    this.items.navbar.toggleClass('active');
                    //this.items.body.toggleClass('prevent-scroll');
                    this.open = !this.open;
                },
                open: function () {
                    this.items.hamburger.addClass('animate');
                    this.items.navbar.addClass('active');
                    //this.items.body.addClass('prevent-scroll');
                    this.open = true;
                },
                close: function () {
                    this.items.hamburger.removeClass('animate');
                    this.items.navbar.removeClass('active');
                    //this.items.body.removeClass('prevent-scroll');
                    this.open = false;
                }
            }
        };

        mobileMenu.items.burgerWrapper.on('click', function () {
            mobileMenu.functions.toggle.call(mobileMenu);
        });


        $('#main-menu').find('.nav-link').on('click', function(){
            $('.header-container').toggleClass('active');

        });


        /*
        ******************************************************************************************************
            Calculates the correct window height and width (including scrollbar)
        ******************************************************************************************************
        */
        function viewport() {
            var e = window, a = 'inner';
            if (!('innerWidth' in window )) {
                a = 'client';
                e = document.documentElement || document.body;
            }
            return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
        }



        /*
        ******************************************************************************************************
            Tables
        ******************************************************************************************************
        */

        $('#content table').each(function(){
            $(this).addClass('table');
        });

        (function () {
            let $table  = $('.table');
            if($table.length > 0){
                $table.each(function(i, table) {
                    $(table).wrap('<div class="table-responsive"></div>');
                });
            }
        })();



        //Extends jQuery with .animateCss() method (used for the language switcher among other things)
        $.fn.extend({
            animateCss: function (animationName, callback) {
                var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
                this.addClass('animated ' + animationName).one(animationEnd, function() {
                    $(this).removeClass('animated ' + animationName);
                    if (callback) {
                        callback();
                    }
                });
                return this;
            }
        });


        //language switcher
        (function () {

            /*
            ******************************************************************************************************
              Language switcher controls
            ******************************************************************************************************
            */
            // Reverse function df
            jQuery.fn.reverse = [].reverse;

            let langSwitcher = {
                open: false,
                items: {
                    body: $('body'),
                    langSwitcher: $('#ar-language-switcher'),
                    langControls: $('#ar-language-switcher .lang-controls'),
                    langItemsInnerWrapper: $('#ar-language-switcher .language-switcher-wrapper .lang-switcher-inner')
                },
                functions: {
                    toggle: function (e) {
                        e.preventDefault();

                        if (this.open === false) {
                            this.items.langControls.siblings('.language-switcher-wrapper').addClass('active');

                            let n = 1, len =   this.items.langItemsInnerWrapper.children('a').length;
                            this.items.langItemsInnerWrapper.children('a').each((index, element) => {
                                //Set delay increment with each loop and apply css
                                let d = 0.10 * n + 's';
                                $(element).animateCss('fadeInLeft').css('animation-delay', d).addClass('active');
                                n++;

                                if (index === (len - 1)) {
                                    this.open = !this.open;
                                }

                            });
                        }  else {
                            this.functions.close.call(this);
                        }

                    },

                    close: function () {
                        let n = 1;
                        this.items.langItemsInnerWrapper.children('a').reverse().each(function () { // get all lang items and reverse the array, then do a foreach
                            let d = 0.10 * n + 's';
                            $(this).css('animation-delay', d).animateCss('fadeOutLeft');
                            n++;
                        });
                        this.items.langControls.siblings('.language-switcher-wrapper').removeClass('active');
                        this.items.langItemsInnerWrapper.children('a').removeClass('active');

                        this.open = false;
                    }
                }
            };


            langSwitcher.items.langControls.on('click', function (e) {
                langSwitcher.functions.toggle.call(langSwitcher, e);
            });

            langSwitcher.items.body.on('click', function (e) {
                if (langSwitcher.open === true && !langSwitcher.items.langSwitcher.find('*').is(e.target)) {
                    langSwitcher.functions.close.call(langSwitcher, e);
                }
            });

        })();

    });

})( jQuery );
